<input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
<button [disabled]="this.loadingFile" (click)="fileUpload.click()" mat-icon-button>
    <mat-icon>upload_file</mat-icon>
</button>
<div class="progress">
    <mat-progress-bar class="progress-bar" mode="determinate" [value]="uploadProgress" *ngIf="uploadProgress">
    </mat-progress-bar>
    <mat-icon class="cancel-upload" (click)="cancelUpload()" *ngIf="uploadProgress">delete_forever</mat-icon>
</div>